export default "__VITE_ASSET__CDXIcRTL__"